const About = () => {
    return (
        <>
            <section>
                <div className="container">
                    <div className="row justify-content-between mt-10">
                        <div className="col-md-4 text-center mb-10">
                            <i className="svg-icon fs-50 text-blue mb-2">
                                <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    x="0px"
                                    y="0px"
                                    width="64px"
                                    height="64px"
                                    viewBox="0 0 64 64"
                                    enableBackground="new 0 0 64 64"
                                    xmlSpace="preserve"
                                >
                                    <polyline
                                        fill="none"
                                        stroke="#000000"
                                        strokeWidth="2"
                                        strokeMiterlimit="10"
                                        points="32,12 32,32 41,41 "
                                    />
                                    <line
                                        fill="none"
                                        stroke="#000000"
                                        strokeWidth="2"
                                        strokeMiterlimit="10"
                                        x1="4"
                                        y1="32"
                                        x2="8"
                                        y2="32"
                                    />
                                    <line
                                        fill="none"
                                        stroke="#000000"
                                        strokeWidth="2"
                                        strokeMiterlimit="10"
                                        x1="56"
                                        y1="32"
                                        x2="60"
                                        y2="32"
                                    />
                                    <line
                                        fill="none"
                                        stroke="#000000"
                                        strokeWidth="2"
                                        strokeMiterlimit="10"
                                        x1="32"
                                        y1="60"
                                        x2="32"
                                        y2="56"
                                    />
                                    <line
                                        fill="none"
                                        stroke="#000000"
                                        strokeWidth="2"
                                        strokeMiterlimit="10"
                                        x1="32"
                                        y1="8"
                                        x2="32"
                                        y2="4"
                                    />
                                    <path
                                        fill="none"
                                        stroke="#000000"
                                        strokeWidth="2"
                                        strokeMiterlimit="10"
                                        d="M32,63c17.121,0,31-13.879,31-31S49.121,1,32,1"
                                    />
                                    <path
                                        fill="none"
                                        stroke="#000000"
                                        strokeWidth="2"
                                        strokeMiterlimit="10"
                                        d="M32,63C14.879,63,1,49.121,1,32
                            c0-6.713,2.134-12.926,5.759-18l5.62-5.621"
                                    />
                                    <polyline
                                        fill="none"
                                        stroke="#000000"
                                        strokeWidth="2"
                                        strokeLinejoin="bevel"
                                        strokeMiterlimit="10"
                                        points="13,19 13,8 2,8 
                            "
                                    />
                                </svg>
                            </i>
                            <h4 className="fs-18 text-uppercase font-weight-normal">
                                Experience
                            </h4>
                            <p>
                                Seasoned{" "}
                                <span className="font-weight-bold">
                                    IT professional
                                </span>{" "}
                                with 8 years of experience working on software
                                projects in various capacities (
                                <span className="font-weight-bold">
                                    Developer
                                </span>
                                , Tester, Scrum Master, PM) and in various
                                industries (Federal Consulting, Industrial
                                Construction, Healthcare, Internet Startups)
                                moving back into a{" "}
                                <span className="font-weight-bold">
                                    software development
                                </span>{" "}
                                roll, my original passion.
                            </p>
                        </div>
                        <div className="col-md-4 text-center mb-10">
                            <i className="svg-icon fs-50 mb-2 text-blue">
                                <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    x="0px"
                                    y="0px"
                                    width="64px"
                                    height="64px"
                                    viewBox="0 0 64 64"
                                    enableBackground="new 0 0 64 64"
                                    xmlSpace="preserve"
                                >
                                    <rect
                                        x="1"
                                        y="1"
                                        fill="none"
                                        stroke="#000000"
                                        strokeWidth="2"
                                        strokeMiterlimit="10"
                                        width="46"
                                        height="62"
                                    />
                                    <line
                                        fill="none"
                                        stroke="#000000"
                                        strokeWidth="2"
                                        strokeMiterlimit="10"
                                        x1="9"
                                        y1="63"
                                        x2="9"
                                        y2="2"
                                    />
                                    <line
                                        fill="none"
                                        stroke="#000000"
                                        strokeWidth="2"
                                        strokeMiterlimit="10"
                                        x1="14"
                                        y1="15"
                                        x2="42"
                                        y2="15"
                                    />
                                    <line
                                        fill="none"
                                        stroke="#000000"
                                        strokeWidth="2"
                                        strokeMiterlimit="10"
                                        x1="14"
                                        y1="21"
                                        x2="42"
                                        y2="21"
                                    />
                                    <polygon
                                        fill="none"
                                        stroke="#000000"
                                        strokeWidth="2"
                                        strokeMiterlimit="10"
                                        points="55,1 55,54 59,62 63,54 63,1 "
                                    />
                                    <line
                                        fill="none"
                                        stroke="#000000"
                                        strokeWidth="2"
                                        strokeMiterlimit="10"
                                        x1="55"
                                        y1="11"
                                        x2="63"
                                        y2="11"
                                    />
                                </svg>
                            </i>
                            <h4 className="fs-18 text-uppercase font-weight-normal">
                                Education
                            </h4>
                            <p>
                                Educated with a{" "}
                                <span className="font-weight-bold">
                                    Computer Science
                                </span>{" "}
                                degree from University of Maryland – University
                                College, an MBA from University of Texas at
                                Austin and most recently a{" "}
                                <span className="font-weight-bold">
                                    Fullstack
                                </span>{" "}
                                Certification from University of North Carolina
                                at Chapel Hill. Enjoys being challenged and
                                engaged with projects that require me to work
                                outside my comfort zone and knowledge set,
                                especially while{" "}
                                <span className="font-weight-bold">
                                    collaborating
                                </span>{" "}
                                with a team.
                            </p>
                        </div>
                        <div className="col-md-4 text-center mb-10">
                            <i className="svg-icon fs-50 text-blue mb-2">
                                <svg
                                    version="1.0"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    x="0px"
                                    y="0px"
                                    width="64px"
                                    height="64px"
                                    viewBox="0 0 64 64"
                                    enableBackground="new 0 0 64 64"
                                    xmlSpace="preserve"
                                >
                                    <rect
                                        x="10"
                                        y="45"
                                        fill="none"
                                        stroke="#000000"
                                        strokeWidth="2"
                                        strokeMiterlimit="10"
                                        width="12"
                                        height="18"
                                    />
                                    <rect
                                        x="42"
                                        y="18"
                                        fill="none"
                                        stroke="#000000"
                                        strokeWidth="2"
                                        strokeMiterlimit="10"
                                        width="12"
                                        height="45"
                                    />
                                    <rect
                                        x="26"
                                        y="32"
                                        fill="none"
                                        stroke="#000000"
                                        strokeWidth="2"
                                        strokeMiterlimit="10"
                                        width="12"
                                        height="31"
                                    />
                                    <g>
                                        <line
                                            fill="none"
                                            stroke="#000000"
                                            strokeWidth="2"
                                            strokeMiterlimit="10"
                                            x1="14"
                                            y1="38"
                                            x2="51"
                                            y2="1"
                                        />
                                        <polyline
                                            fill="none"
                                            stroke="#000000"
                                            strokeWidth="2"
                                            strokeLinejoin="bevel"
                                            strokeMiterlimit="10"
                                            points="40,1 51,1 51,12 
                    "
                                        />
                                    </g>
                                </svg>
                            </i>

                            <h4 className="fs-18 text-uppercase font-weight-normal">
                                Results
                            </h4>
                            <p>
                                Has successfully contributed on a variety of
                                technology stacks for both greenfield and
                                existing code bases and has managed/facilitated{" "}
                                <span className="font-weight-bold">
                                    software teams
                                </span>{" "}
                                and implemented{" "}
                                <span className="font-weight-bold">
                                    Agile/Scrum
                                </span>{" "}
                                from the ground up resulting in major successes.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default About;
